var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
export function ContractDelete(_a) {
    var color = _a.color, size = _a.size;
    return (_jsx("svg", __assign({ width: size, height: size, viewBox: "0 0 48 48", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: _jsx("path", { d: "M33.85 42.7L31.75 40.6L36 36.35L31.75 32.1L33.85 30L38.1 34.25L42.35 30L44.45 32.1L40.2 36.35L44.45 40.6L42.35 42.7L38.1 38.45L33.85 42.7ZM18 16V13H36V16H18ZM18 22V19H36V22H18ZM11.25 44C9.78333 44 8.54167 43.4917 7.525 42.475C6.50833 41.4583 6 40.2167 6 38.75V32H12V4H42V26.3C41.5333 26.1333 41.05 26 40.55 25.9C40.05 25.8 39.5333 25.7167 39 25.65V7H15V32H28.3C28 32.7 27.775 33.4167 27.625 34.15C27.475 34.8833 27.4 35.6167 27.4 36.35C27.4 37.75 27.6667 39.1167 28.2 40.45C28.7333 41.7833 29.5333 42.9667 30.6 44H11.25Z", fill: color }) })));
}
